
import * as actions from 'actions';
import lastTimeRefreshMaker from 'reducersMakers/lastTimeRefreshMaker';

export default lastTimeRefreshMaker(actions.TIME_REFRESH);



/** WEBPACK FOOTER **
 ** ./src/members/state/lastTimeRefresh/reducer.js
 **/